import { connect } from 'react-redux'
import undefsafe from 'undefsafe'

import { setActiveAudio } from '../../../common/actions/searchPage'
import AudioPlayerLarge from './audioPlayerLarge'

const mapStateToProps = (state, ownProps) => {
  const itemAudioSrc = undefsafe(ownProps, 'item.previews.icon_with_audio_preview.mp3_url')
  const {
    searchPage: {
      activeAudio
    }
  } = state

  return {
    isActive: itemAudioSrc && itemAudioSrc === activeAudio
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const itemAudioSrc = undefsafe(ownProps, 'item.previews.icon_with_audio_preview.mp3_url')
  return {
    onPlay: () => dispatch(setActiveAudio(itemAudioSrc))
  }
}

const AudioPlayerLargeContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AudioPlayerLarge)

export default AudioPlayerLargeContainer



// WEBPACK FOOTER //
// ./client/components/audio/audioPlayerLargeContainer.js